import { render } from "./SalesPaytsMonthListPage.vue?vue&type=template&id=c70d516e&ts=true"
import script from "./SalesPaytsMonthListPage.vue?vue&type=script&lang=ts"
export * from "./SalesPaytsMonthListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__